(function () {
  function getActiveVideos(root) {
    let videos = root.querySelectorAll('.vx-hero__video');
    let active = [];
    let isMobile = window.matchMedia('(max-width: 767px)').matches;
    let hasMobile = root.classList.contains('vx-hero--has-mobile-video');

    for (let i = 0; i < videos.length; i++) {
      let video = videos[i];
      let isDesktopEl = video.classList.contains('vx-hero__video--desktop');
      let isMobileEl = video.classList.contains('vx-hero__video--mobile');

      if (hasMobile) {
        if (isMobile && isMobileEl) active.push(video);
        else if (!isMobile && isDesktopEl) active.push(video);
        else {
          video.pause();
        }
      } else {
        active.push(video);
      }
    }
    return active;
  }

  function init(root) {
    if (!root || root.dataset.vxInit) return;
    root.dataset.vxInit = '1';

    let reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    let videos = root.querySelectorAll('.vx-hero__video');
    if (!videos.length) return;

    let syncPlayback = function () {
      let active = getActiveVideos(root);
      for (let i = 0; i < active.length; i++) {
        let video = active[i];
        if (reduce) {
          video.pause();
          continue;
        }
        let p = video.play();
        if (p && p.catch) p.catch(function () {});
      }
    };

    syncPlayback();

    let mq = window.matchMedia('(max-width: 767px)');
    if (mq.addEventListener) mq.addEventListener('change', syncPlayback);
    else mq.addListener(syncPlayback);

    if (!reduce && 'IntersectionObserver' in window) {
      new IntersectionObserver(
        function (entries) {
          if (!entries[0].isIntersecting) {
            for (let i = 0; i < videos.length; i++) videos[i].pause();
            return;
          }
          syncPlayback();
        },
        { threshold: 0.05 }
      ).observe(root);
    }

    root.querySelectorAll('a[href^="#"]').forEach(function (a) {
      a.addEventListener('click', function (e) {
        let id = decodeURIComponent(a.getAttribute('href').slice(1));
        let target = id && document.getElementById(id);
        if (!target) return;
        e.preventDefault();
        let y = target.getBoundingClientRect().top + window.pageYOffset;
        window.scrollTo({ top: y, behavior: reduce ? 'auto' : 'smooth' });
        if (history.replaceState) history.replaceState(null, '', '#' + id);
      });
    });
  }

  function boot(scope) {
    let roots = (scope || document).querySelectorAll('[data-vx-hero]');
    for (let i = 0; i < roots.length; i++) init(roots[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      boot();
    });
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (e) {
    let section = e.target;
    if (!section) return;
    let root = section.querySelector('[data-vx-hero]');
    if (!root) return;
    delete root.dataset.vxInit;
    init(root);
  });
})();
